export default __webpack_public_path__ + "63e3a03954dc9bb9bc81b051ed1cf73b.svg";